import { dtsAPI } from "../../axios";

export const actions = {

    // Track Rating
    GetTrackRating(context, data){
        return dtsAPI.get(`TrackRating/Track/${data}`);
    },
    GetSingleTrackRating(context, data){
        return dtsAPI.get(`TrackRating/${data}`);
    },
    CreateTrackRating(context, data){
        return dtsAPI.post(`TrackRating`, data);
    },

}